import { HubUserAttributesClient } from 'frontend-preferences-client';
export const hubUserAttributesClient = HubUserAttributesClient.forCaller('svh-conversations-settings-lib');